import { AppState } from "@shared/interfaces";
import { createSelector } from "reselect";

const selectEvaluation = (state: AppState) => state.evaluation;

export const getEvalRuns = () => createSelector(selectEvaluation, (state) => state.runs);
export const getEvalRunsTotal = () => createSelector(selectEvaluation, (state) => state.runsTotal);
export const getActiveRun = () => createSelector(selectEvaluation, (state) => state.activeRun);
export const getEvalDatasets = () => createSelector(selectEvaluation, (state) => state.datasets);
export const getFilter = () => createSelector(selectEvaluation, (state) => state.filter);
export const getSubmitError = () => createSelector(selectEvaluation, (state) => state.submitError);
export const getLastSubmittedUuid = () => createSelector(selectEvaluation, (state) => state.lastSubmittedUuid);
export const getLoadError = () => createSelector(selectEvaluation, (state) => state.loadError);
